import { Component } from '@angular/core';
import { AuthentificationService } from '../../services/auth/authentification.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { StorageUtil } from '../../utils/storage.util';
import { CookieService } from 'ngx-cookie-service';

@Component({
  moduleId: module.id,
  templateUrl: 'signin.component.html',
  providers: []
})
export class SignInComponent {

  constructor(
    private router: Router,
    private authService: AuthentificationService,
    private cookieService: CookieService,
  ) {
  }

  ngOnInit() {
    this.saveCookiesData();
  }

  getSignIn() {
    this.authService.signIn().subscribe(
      success => {
        if (success) {
          this.saveCookiesData();
        }
      },
      error => {
        this.saveCookiesData();
      },
      () => {
      });
  }

  saveCookiesData() {
    console.log(this.cookieService.get('secureToken'));
    let token = this.cookieService.get('secureToken');
    if (token) {
      AuthentificationService.saveToken(token);
    }
    let tenantName = this.cookieService.get('tenantName');
    if (tenantName) {
      StorageUtil.setTenantName(tenantName);
    }
    let tenantType = this.cookieService.get('tenantType');
    if (tenantType) {
      StorageUtil.setTenantType(tenantType);
    }

    this.router.navigate(['/main']);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/signin/signin.component.ts